export default __webpack_public_path__ + "static/media/ic-abstract-01.9e13b0e1.svg";